// 수행평가
import Resource from './Resource'
import axios from 'axios';

export default class Auth extends Resource {
  static ENDPOINT = '/api/auth'

  static async nice (org) {
    const res = await axios.get(`${this.ENDPOINT}/nice/${org}`);
    return res.data
  }

  static async login (profile) {
    const { data } = await axios.post(`${this.ENDPOINT}/login`, profile);
    return data
  }

  static async logout () {
    const { data } = await axios.get(`${this.ENDPOINT}/logout`);
    return data
  }

  static async join (profile) {
    const { data } = await axios.post(`${this.ENDPOINT}/join`, profile);
    return data
  }

  static async isexist (userId) {
    const { data } = await axios.get(`${this.ENDPOINT}/isexist/${userId}`);
    return data
  }

  static async check (profile) {
    const { data } = await axios.post(`${this.ENDPOINT}/check`, profile);
    return data
  }

  static async getProfile () {
    const res = await axios.get(`${this.ENDPOINT}/profile`);
    return res.data;
  }

  static async updateProfile (user) {
    const res = await axios.put(`${this.ENDPOINT}/profile`, user);
    return res.data;
  }

  static async changePassword (data) {
    const res = await axios.put(`${this.ENDPOINT}/password`, data);
    return res.data;
  }

  static async checkPassword (userId, password) {
    const res = await axios.post(`${this.ENDPOINT}/checkpassword`, { userId, password });
    return res.data
  }
}
